"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _warning = _interopRequireDefault(require("warning"));

var warned = {};

var warningOnce = function warningOnce(condition, message) {
  if (warned[message]) {
    return;
  }

  (0, _warning.default)(condition, message);
  warned[message] = !condition;
};

var _default = warningOnce;
exports.default = _default;